import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum Experience {
  Beginner = "Beginner",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
}

const experienceQuestion = {
  name: "experience",
  title: loc("quiz.experience.title"),
  type: "radiogroup",
  description: loc("quiz.experience.description"),
  choices: [
    {
      value: Experience.Beginner,
      text: locIconButton("quiz.experience.choices.beginner", "🚶"),
    },
    {
      value: Experience.Intermediate,
      text: locIconButton("quiz.experience.choices.intermediate", "🏃‍♂️"),
    },
    {
      value: Experience.Advanced,
      text: locIconButton("quiz.experience.choices.advanced", "🏋️"),
    }
  ],
  isRequired: true,
};

export {
  experienceQuestion,
  Experience,
}